import { render, staticRenderFns } from "./loans.vue?vue&type=template&id=82210598&scoped=true&"
import script from "./loans.vue?vue&type=script&lang=js&"
export * from "./loans.vue?vue&type=script&lang=js&"
import style0 from "./loans.vue?vue&type=style&index=0&id=82210598&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82210598",
  null
  
)

export default component.exports